import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";
import axios from "axios";

const initialState = {
    data: [],
    response: null,
    loading: false,
    error: null,
    count: 0,
    cardDataCount: null
};

//  GET ALL
export const getAllAutomationMarkerting = createAsyncThunk(
    "getAllAutomationMarkerting",
    async () => {
        try {
            const response = await axios.get(
                "https://apiai.remarkhr.com/marketing_automation"
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const AutomationMarketingSlice = createSlice({
    name: "AutomationMarketingSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        //  GET
        builder.addCase(getAllAutomationMarkerting.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getAllAutomationMarkerting.fulfilled, (state, action) => {
            state.loading = false;

            state.data = action.payload?.data || [];
            state.count = action.payload?.count || 0;
            state.cardDataCount = action.payload?.cardDataCount || null;
        });

        builder.addCase(getAllAutomationMarkerting.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});

export default AutomationMarketingSlice.reducer;